<template>
    <div class="flex items-center gap-1">
        <div
            v-for="type in types"
            class="flex items-center gap-2"
        >
            <MeetingLocationIcon
                :type="type"
                :iconSize="meetingLocationIconSize"
            />
            <span v-if="types.length === 1">
                {{
                    localizer.translate(
                        Service.getLocalizationTokenByType(type),
                    )
                }}
            </span>
        </div>
    </div>
</template>

<script setup lang="ts">
    import type { PropType } from 'vue'
    import { MeetingLocationTypeEnum } from '@/Shared/AutoGenerated/Main'
    import MeetingLocationIcon from '@/BookingForm/BookingForm/Page/Step/MeetingLocationIcon.vue'
    import Service from '@/App/Service/Entity/Service'
    import LocalizerService from '@/Shared/Service/Localization/LocalizerService'

    const props = defineProps({
        types: {
            type: Array as PropType<MeetingLocationTypeEnum[]>,
            required: true,
        },
        meetingLocationIconSize: {
            type: Number,
            required: true,
        },
        localizer: {
            type: Object as PropType<LocalizerService>,
            required: true,
        },
    })
</script>
